import { ProfileState } from '../../types/profile-module.types';

export const state: ProfileState = {
  reviews: [],
  profile: null,
};
